import React, { useEffect, useState, useRef } from 'react';
import EditarPerfil from '../../SVG/Editarperfil.svg';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../css/editInfo.css';
import {
  actualizarUsuario,
  obtenerUsuarioActual,
  verificarCorreo,
  verificarTelefono,
  validarCorreo,
  validarTelefono,
  ObtenerPaisesPrefijos,
} from '../../redux/usuariosSlice';
import OperationStatus from '../../config/OperationStatus';
import Modal from '../../Adm/Components/Modal';
import WindowDimension from '../../Hooks/WindowDimension';
import ReactSelect from '../../Components/ReactSelect';
import { getEditUser } from '../../Api/content';
import { useLocale } from '../../i18n/localeContext';
import { useValidation } from '../../Hooks/useValidation';
import { Skeleton } from 'antd';
import { StrapiError } from '../../Inicio/Pages/StrapiError';
export default function EditInfo(props) {
  const { usuario, prefijosLista } = useSelector((state) => state.usuarios);

  const { width } = WindowDimension();
  const { locale } = useLocale();
  const { validation } = useValidation();

  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [tieneImagen, setTieneImagen] = useState(false);
  const [editUserContent, setEditUserContent] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [showModalCorreo, setShowModalCorreo] = useState(false);
  const [showModalTelefono, setShowModalTelefono] = useState(false);
  const fileInput = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const consultadoEnPadron = watch('consultadoEnPadron');
  const telefonoValidado = watch('telefonoValidado');
  const correoValidado = watch('correoValidado');

  const {
    register: registerModal,
    formState: { errors: errorsModal },
    handleSubmit: handleModalSubmit,
    reset: resetModal,
  } = useForm();
  const {
    register: registerTel,
    formState: { errors: errorsTel },
    handleSubmit: handleTelSubmit,
    reset: resetTel,
  } = useForm();

  useEffect(() => {
    dispatch(obtenerUsuarioActual());
    dispatch(ObtenerPaisesPrefijos());
  }, [dispatch]);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setEditUserContent(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);
    getEditUser(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setEditUserContent(data);
          setIsLoadingContent(false);
        }
      })
      .catch((error) => { 
        clearTimeout(timeoutId);
        if (!cancel) {
          setEditUserContent(null);
          setHasError(locale === 'en');
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true; 
      clearTimeout(timeoutId); };
  }, [locale]);

  useEffect(() => {
    reset(usuario);
    if (usuario.foto) {
      setTieneImagen(true);

      setPreview(`data:image/jpg;base64, ${usuario.foto}`);
    }
  }, [usuario, reset]);

  const [lista, setLista] = useState([]);

  useEffect(() => {
    let a = prefijosLista?.map((item, i) => {
      return { label: item.codigoArea + ' ' + item.paisNombre, value: item.id };
    });
    setLista(a);
  }, [prefijosLista]);

  const onChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
      setTieneImagen(true);
    } else {
      setImage(null);
      tieneImagen(false);
    }
  };
  const onSubmit = async (data) => {
    var fData = new FormData();
    fData.append('Dni', data.dni);
    fData.append('Nombres', data.nombres);
    fData.append('alias', data.alias);
    fData.append('PrimerApellido', data.primerApellido);
    fData.append('SegundoApellido', data.segundoApellido);
    fData.append('CorreoElectronico', data.correoElectronico);
    fData.append('Fotografia', image);
    fData.append('TelefonoPrefijoId', data.telefonoPrefijoId);
    fData.append('TelefonoSufijo', data.telefonoSufijo);

    if (usuario.fotografiaId !== null)
      fData.append('FotografiaId', usuario.fotografiaId);

    let { payload } = await dispatch(actualizarUsuario(fData));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      dispatch(obtenerUsuarioActual());
    } else {
      toast.error(payload.message);
    }
  };

  const onSubmitCorreo = async (data) => {
    let { payload } = await dispatch(validarCorreo(data.codigo));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      dispatch(obtenerUsuarioActual());
      toast.success(payload.message);
      closeModal();
    } else {
      toast.error(payload.message);
    }
  };
  const onSubmitTelefono = async (data) => {
    let { payload } = await dispatch(validarTelefono(data.codigo));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      dispatch(obtenerUsuarioActual());
      toast.success(payload.message);
      closeModal();
    } else {
      toast.error(payload.message);
    }
  };

  const correoValidar = async (e) => {
    e.preventDefault();

    let { payload } = await dispatch(verificarCorreo());

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      setShowModalCorreo(true);
    } else {
      toast.error(payload.message);
    }
  };
  const telefonoValidar = async (e) => {
    e.preventDefault();

    let { payload } = await dispatch(verificarTelefono());

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      setShowModalTelefono(true);
    } else {
      toast.error(payload.message);
    }
  };
  const closeModal = (e) => {
    setShowModalCorreo(false);
    setShowModalTelefono(false);
    resetModal({ codigo: '' });
    resetTel({ codigo: '' });
  };

  if (isLoadingContent) {
    return (
      <div className="rootEdit">
        <div className="principal">
          <div className="container-root">
            <div className="grid-container container col-2 col-md">
              <div>
                <div className="grid-container col-2 col-lg-2 col-sm-12">
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 200, height: 20 }} active />
                      <Skeleton.Image style={{ width: 150, height: 150 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 150, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 100, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 120, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 140, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 160, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                </div>
                <div className="grid-container col-2 col-lg col-md col-sm-12">
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 120, height: 20 }} active />
                      <div className="d-flex flex-gap-2">
                        <Skeleton.Input style={{ width: 100, height: 40 }} active />
                        <Skeleton.Input style={{ width: 150, height: 40 }} active />
                        <Skeleton.Button style={{ width: 80, height: 40 }} active />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-control">
                <Skeleton.Image style={{ width: 200, height: 150 }} active />
                <div>
                  <Skeleton.Button style={{ width: 100, height: 40 }} active />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setEditUserContent(null);
      }}
    />
  }

  return (
    <>
      <div className="rootEdit">
        <div className="principal">
          <div className="container-root">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid-container container col-2 col-md">
                <div>
                  <div className="grid-container col-2 col-lg-2 col-sm-12">
                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_photo_passport || 'Fotografía (Tipo pasaporte)'}</label>
                        <div className="div-relative">
                          {tieneImagen ? (
                            <>
                              <img
                                className="img-perfil imagen-cuadrada"
                                alt="Imagen de perfil"
                                src={preview}
                              />
                              <button
                                className="btn-quit-image"
                                type="button"
                                onClick={() => {
                                  setImage(null);
                                  setTieneImagen(false);
                                }}
                              >
                                <i className="material-icons"></i>
                              </button>
                            </>
                          ) : (
                            <>
                              <input
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onInput={onChange}
                                ref={(ref) => {
                                  fileInput.current = ref;
                                }}
                                name="archivo"
                              />
                              <button
                                className="btn-load-image"
                                type="button"
                                onClick={() => {
                                  fileInput.current.click();
                                }}
                              >
                                {editUserContent?.add_button || 'Añadir imagen'}
                              </button>

                              {errors.archivo && (
                                <p className="error">
                                  {errors.archivo.message}
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_ide || 'No. de identificación'}</label>
                        <input
                          className="form-control"
                          disabled={consultadoEnPadron}
                          type="text"
                          {...register('dni', {
                            required: validation?.required_field || 'Campo requerido',
                          })}
                        />
                        {errors.dni && (
                          <p className="error">{errors.dni.message}</p>
                        )}
                      </div>
                    </div>

                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_name || 'Nombre(s)'}</label>
                        <input
                          disabled={consultadoEnPadron}
                          className="form-control"
                          {...register('nombres', {
                            required: validation?.required_field || 'Campo requerido',
                          })}
                          type="text"
                        />
                        {errors.nombres && (
                          <p className="error">{errors.nombres.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_nickname || 'Conocido como'}</label>
                        <input
                          disabled={consultadoEnPadron}
                          className="form-control"
                          {...register('alias')}
                          type="text"
                        />
                        {errors.alias && (
                          <p className="error">{errors.alias.message}</p>
                        )}
                      </div>
                    </div>

                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_lastnameO || 'Primer Apellido'}</label>
                        <input
                          disabled={consultadoEnPadron}
                          className="form-control"
                          type="text"
                          {...register('primerApellido', {
                            required: validation?.required_field || 'Campo requerido',
                          })}
                        />
                        {errors.primerApellido && (
                          <p className="error">
                            {errors.primerApellido.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_lastnameT || 'Segundo Apellido'}</label>
                        <input
                          disabled={consultadoEnPadron}
                          className="form-control"
                          type="text"
                          {...register('segundoApellido', {
                            required: validation?.required_field || 'Campo requerido',
                          })}
                        />
                        {errors.segundoApellido && (
                          <p className="error">
                            {errors.segundoApellido.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_email || 'Correo electrónico'}</label>
                        <div className="d-flex">
                          <input
                            className="form-control"
                            type="email"
                            {...register('correoElectronico', {
                              required: validation?.required_field || 'Campo requerido',
                              pattern: {
                                value: /^\S+@\S+$/i,
                                message: validation?.invalid_email || 'Escriba un correo valido',
                              },
                            })}
                          />
                          {!correoValidado && (
                            <button
                              className="button-text"
                              onClick={correoValidar}
                            >
                              {editUserContent?.validate_button || "Validar"}
                            </button>
                          )}
                        </div>
                        {errors.correoElectronico && (
                          <p className="error">
                            {errors.correoElectronico.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid-container col-2 col-lg col-md col-sm-12">
                    <div className="grid-item">
                      <div className="form-group">
                        <label>{editUserContent?.user_phone || 'No. de teléfono'}</label>
                        <div className="d-flex flex-gap-2">
                          <div className="select-container">
                            <ReactSelect
                              name="telefonoPrefijoId"
                              control={control}
                              lista={lista}
                              rules={{ required: validation?.required_field || 'Campo requerido' }}
                            />
                          </div>

                          <input
                            className="form-control"
                            type="text"
                            {...register('telefonoSufijo', {
                              required: validation?.required_field || 'Campo requerido',
                            })}
                          />

                          {!telefonoValidado && (
                            <button
                              className="button-text"
                              onClick={telefonoValidar}
                            >
                              {editUserContent?.validate_button || "Validar"}
                            </button>
                          )}
                        </div>
                        {errors.telefonoPrefijoId && (
                          <p className="error">
                            {errors.telefonoPrefijoId.message}
                          </p>
                        )}
                        {errors.telefonoSufijo && (
                          <p className="error">
                            {errors.telefonoSufijo.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="button-control">
                  <img src={EditarPerfil} alt="Imagen editar perfil" />
                  <div>
                    <button type="submit">{editUserContent?.save_button || 'Guardar'}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal
        estado={showModalCorreo}
        cambiarEstado={() => {
          closeModal();
        }}
        titulo={editUserContent?.subtitleO || "Verificar correo"}
        clase={`${width < 576 ? 'full-width' : 'small'}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleModalSubmit(onSubmitCorreo)}
            >
              {editUserContent?.verify_button || "Verificar"}
            </button>
          </>
        }
      >
        <form>
          <span className="body-text mt-2 mb-2">
            {editUserContent?.description || "Se ha enviado un correo con el código de verificación"}
          </span>

          <div className="form-group">
            <i className="material-icons important"></i>
            <label>{editUserContent?.verifycode || "Código de verificación"}</label>
            <input
              className="form-control"
              {...registerModal('codigo', { required: validation?.required_field || 'Campo requerido' })}
            />
            {errorsModal.codigo && (
              <p className="error">{errorsModal.codigo.message}</p>
            )}
          </div>
        </form>
      </Modal>
      <Modal
        estado={showModalTelefono}
        cambiarEstado={closeModal}
        titulo="Verificar teléfono"
        clase={`${width < 576 ? 'full-width' : 'small'}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleTelSubmit(onSubmitTelefono)}
            >
              {editUserContent?.verify_button || "Verificar"}
            </button>
          </>
        }
      >
        <form>
          <span className="body-text mt-2 mb-2">
            {editUserContent?.number_message || "Se ha enviado un sms con el código de verificación"}
          </span>

          <div className="form-group">
            <i className="material-icons important"></i>
            <label>{editUserContent?.verifycode || "Código de verificación"}</label>
            <input
              className="form-control"
              {...registerTel('codigo', { required: validation?.required_field || 'Campo requerido' })}
            />
            {errorsTel.codigo && (
              <p className="error">{errorsTel.codigo.message}</p>
            )}
          </div>
        </form>
      </Modal>
    </>
  );
}
